<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      v-if="trendShow"
      row-key="ProductTypeId"
      ref="list"
      unit="存货类型"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="false"
      :get-data-func="api.list"
      :getColumn="tableColumns"
      :trendColumn="trendColumn"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/basedata/inventory/types/list.json";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      formApi: require("@/api/sy/formSetting").default,
      tableApi: require("@/api/sy/tableSetting").default,
      api: require("@/api/ba/productType").default,
      trendColumn: tableColumn.Data,
      tableColumns: tableColumn.Data,
      trendShow: true,
    };
  },

  mounted() {
    console.log("1");
    // 
    
  },

  methods: {
    //
    getFormData() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        if (res.Data === null || res.Data.length === 0) return;
        if (res.Code == 0) {
          const ShowField = res.Data.map((x) => x.ShowField);
          this.fromData.map((item) => {
            item.show = ShowField.indexOf(item.field) !== -1 ? true : false;
          });
        }
      });
    },
    showTable() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.tableApi
        .list({ type: modeName })
        .then((res) => {
          if (res.Data === null || res.Data.length === 0) {
            return (this.trendShow = true);
          }
          if (res.Code == 0) {
            const ShowField = res.Data.map((x) => x.ShowField);
            this.tableColumns.forEach((item) => {
              const DataItem = res.Data.filter(
                (x) => x.ShowField == item.tableName
              );
              if (ShowField.indexOf(item.tableName) !== -1) {
                item.col.width = DataItem[0].ShowWidth;
                item.props.align = DataItem[0].Alignment;
                item.props.tooltip = DataItem[0].IsHidden;
              }
              // item.props.show = true
              item.props.show =
                ShowField.indexOf(item.tableName) !== -1 ? true : false;
            });
            this.trendShow = true;
            return (this.tableColumns = this.tableColumns.filter(
              (x) => x.props.show == true
            ));
          }
        })
        .then((res) => {
          this.getData();
        });
    },

    //
    showParams() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.queryApi.list({ type: modeName }).then((res) => {
        if (res.Data === null || res.Data.length === 0) return;
        if (res.Code == 0) {
          const ShowField = res.Data.map((x) => x.ShowField);
          this.tableParams.forEach((item) => {
            const DataItem = res.Data.filter((x) => x.ShowField == item.field);
            if (ShowField.indexOf(item.field) !== -1) {
              item.col.labelWidth = DataItem[0].TagsWidth;
              item.col.width = DataItem[0].ShowWidth;
            }
            // item.props.show = true
            item.props.show =
              ShowField.indexOf(item.field) !== -1 ? true : false;
          });
          return (this.tableParams = this.tableParams.filter(
            (x) => x.props.show == true
          ));
        }
      });
    },

    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>